<div class="rm-header">
  <span *ngIf="!data.isRondeivu">Sub Doc Review/Edit & Approve for Signature(s)</span>
  <span *ngIf="data.isRondeivu">[ADMIN] Sub Doc Review/Edit & Approve for Investor Review</span>
</div>

<div class="pt-4 space-between">
    <span style="font-size: large;">
      SubDoc Fill
    </span>

    <button mat-raised-button type="button" color="primary"
          (click)="downloadSubdoc()"
    >
    Download SubDoc PDF
    </button>
</div>

<div class="row pt-3">
  <div class="col-12 pb-3" *ngIf="util.isAdmin()" style="display: flex; flex-direction: column;">
    <div style="font-weight: bold;">
      {{data.fields.agreementTitle}}
    </div>
    <div>
      <em class="text-muted" style="font-size: x-small">
        {{data.fields.agreementDescription}}
      </em>
    </div>
  </div>
  <div class="col-12">
    <p>
      Your Subscription Document has been generated in ConcordNow (our partner for contract lifecycle management).
      <br>
      You can use the web form below to view the SubDoc and fill in the required information, or edit the information that has been pre-filled by our platform using your Approved KYC.
    </p>
  </div>
  <div class="col-12" style="display: flex; gap: 100px; overflow-x: hidden;">
    <span *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]">
      <mat-icon color="primary">arrow_downward</mat-icon>
    </span>
  </div>
</div>
<mat-dialog-content style="border-top: thick solid #ccc; border-bottom: thick solid #ccc">
  <!-- this section is where the html for the subdoc is compiled and placed  -->
  <div [innerHTML]="safeHtml" #docBody>Inner HTML Not working</div>
</mat-dialog-content>

<mat-dialog-actions class="space-between">
  <button mat-raised-button type="button" [mat-dialog-close]="false">Close</button>
  
  
  <div style="display: flex; justify-items: end; justify-content: end; gap: 10px;" *ngIf="data.isRondeivu">
    <button mat-raised-button type="button" color="primary" (click)="saveFieldsForRondeivu(false)">Save Draft</button>
    <button mat-raised-button type="button" color="primary" (click)="saveFieldsForRondeivu(true)">Save Document & Send to Investor Review</button>
  </div>

   <div style="display: flex; justify-items: end; justify-content: end; gap: 10px;" *ngIf="!data.isRondeivu">
    <button mat-raised-button type="button" color="primary" (click)="saveFields(false)">Save Draft</button>
    <button *ngIf="!data.isRondeivu" mat-raised-button type="button" color="primary" (click)="saveFields(true)">Save Document & Send to Investor Signers</button>
  </div>
</mat-dialog-actions>
